import { useState, useEffect, useRef } from 'react';

function MessageModal(props) {
    const DEFAULT_MESSAGE = {
        key: '',
        name: '',
        description: '',
        subject: '',
        emailBody: '',
        smsBody: '',
        telegramBody: '',
        pushBody: '',
        variables: ''
    };

    const [error, setError] = useState('');
    const [message, setMessage] = useState(DEFAULT_MESSAGE);

    useEffect(() => {
        if (!props.data || !props.data.id) {
            setMessage({ ...DEFAULT_MESSAGE });
        } else {
            setMessage({ ...props.data });
        }
    }, [props.data]);

    useEffect(() => {
        const modal = document.getElementById('modalMessage');
        if (modal) {
            modal.addEventListener('hidden.bs.modal', () => {
                setMessage({ ...DEFAULT_MESSAGE });
                setError('');
            });
        }
    }, []);

    function onInputChange(event) {
        setMessage(prevState => ({ ...prevState, [event.target.id]: event.target.value }));
    }

    function onSubmit(event) {
        event.preventDefault();
        setError('');

        if (!message.key || !message.name) {
            setError('Chave e nome são obrigatórios.');
            return;
        }

        // Validar formato da chave (sem espaços, apenas letras, números e underscore)
        if (!/^[a-zA-Z0-9_]+$/.test(message.key)) {
            setError('A chave deve conter apenas letras, números e underscore (sem espaços).');
            return;
        }

        props.onSubmit(message);
    }

    return (
        <div className="modal fade" id="modalMessage" tabIndex="-1" role="dialog" aria-labelledby="modalMessageLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title" id="modalMessageLabel">
                            {message.id ? 'Editar Mensagem' : 'Nova Mensagem'}
                        </p>
                        <button ref={props.btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <form onSubmit={onSubmit}>
                        <div className="modal-body">
                            {error && (
                                <div className="alert alert-danger">{error}</div>
                            )}
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="key">Chave <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            id="key"
                                            type="text"
                                            placeholder="ex: welcome_email"
                                            value={message.key || ''}
                                            onChange={onInputChange}
                                            disabled={!!message.id}
                                            required
                                        />
                                        <small className="text-muted">Identificador único da mensagem (não pode ser alterado após criação)</small>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="name">Nome <span className="text-danger">*</span></label>
                                        <input
                                            className="form-control"
                                            id="name"
                                            type="text"
                                            placeholder="ex: Email de Boas-vindas"
                                            value={message.name || ''}
                                            onChange={onInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="description">Descrição</label>
                                        <input
                                            className="form-control"
                                            id="description"
                                            type="text"
                                            placeholder="Breve descrição desta mensagem"
                                            value={message.description || ''}
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="subject">Assunto (para email)</label>
                                        <input
                                            className="form-control"
                                            id="subject"
                                            type="text"
                                            placeholder="Assunto do email"
                                            value={message.subject || ''}
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="emailBody">Corpo do Email</label>
                                        <textarea
                                            className="form-control"
                                            id="emailBody"
                                            rows="6"
                                            placeholder="Conteúdo do email. Use variáveis como {{userName}}, {{password}}, {{url}}, etc."
                                            value={message.emailBody || ''}
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="smsBody">Mensagem SMS</label>
                                        <textarea
                                            className="form-control"
                                            id="smsBody"
                                            rows="3"
                                            placeholder="Mensagem SMS (curta)"
                                            value={message.smsBody || ''}
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="telegramBody">Mensagem Telegram</label>
                                        <textarea
                                            className="form-control"
                                            id="telegramBody"
                                            rows="4"
                                            placeholder="Mensagem para Telegram"
                                            value={message.telegramBody || ''}
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="pushBody">Mensagem Push</label>
                                        <textarea
                                            className="form-control"
                                            id="pushBody"
                                            rows="3"
                                            placeholder="Mensagem para notificação push"
                                            value={message.pushBody || ''}
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="variables">Variáveis Disponíveis (JSON)</label>
                                        <textarea
                                            className="form-control"
                                            id="variables"
                                            rows="3"
                                            placeholder='["userName", "password", "url", "telegramBot"]'
                                            value={message.variables || ''}
                                            onChange={onInputChange}
                                        />
                                        <small className="text-muted">Lista de variáveis disponíveis para esta mensagem (formato JSON array)</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            <button type="submit" className="btn btn-primary">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default MessageModal;



